var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8874_29674)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 12.8008,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 13.5078C28.0421 13.5078 21.5094 20.0407 21.5094 28.099C21.5094 36.1572 28.0421 42.6901 36.1 42.6901C44.158 42.6901 50.6906 36.1572 50.6906 28.099C50.6906 20.0407 44.158 13.5078 36.1 13.5078ZM34.0102 35.4369C27.8589 31.3248 20.9838 23.7395 26.3623 18.3608C31.7407 12.9822 40.4593 12.9822 45.8378 18.3608C50.2074 22.7306 50.7078 29.1662 48.2951 34.5037C46.8787 37.6367 40.3334 39.6636 34.0102 35.4369Z",
    fill: "#FBC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.616 31.0042V23.7632H31.4467V31.0042H29.616ZM26.9109 28.299V26.4684H34.1518V28.299H26.9109ZM39.955 32.7428C39.2322 32.7428 38.5879 32.6098 38.022 32.3439C37.4595 32.078 37.0129 31.7115 36.6822 31.2445C36.3516 30.7775 36.1794 30.2422 36.1658 29.6388H38.3135C38.3374 30.0445 38.5078 30.3735 38.8249 30.6257C39.1419 30.878 39.5186 31.0042 39.955 31.0042C40.3027 31.0042 40.6095 30.9275 40.8754 30.774C41.1447 30.6172 41.3544 30.4007 41.5044 30.1246C41.6578 29.8451 41.7345 29.5246 41.7345 29.1632C41.7345 28.7951 41.6561 28.4712 41.4993 28.1917C41.3459 27.9121 41.1328 27.6939 40.8601 27.5371C40.5874 27.3803 40.2754 27.3002 39.9243 27.2968C39.6175 27.2968 39.3192 27.3598 39.0294 27.486C38.743 27.6121 38.5197 27.7843 38.3595 28.0025L36.3908 27.6496L36.8868 22.1269H43.2891V23.9371H38.7124L38.4413 26.5604H38.5027C38.6868 26.3013 38.9646 26.0865 39.3362 25.9161C39.7078 25.7456 40.1237 25.6604 40.5839 25.6604C41.2146 25.6604 41.7771 25.8087 42.2714 26.1053C42.7658 26.4019 43.1561 26.8093 43.4425 27.3275C43.7288 27.8422 43.8703 28.4354 43.8669 29.107C43.8703 29.8127 43.7067 30.44 43.376 30.9888C43.0487 31.5343 42.5902 31.9638 42.0004 32.2775C41.4141 32.5877 40.7322 32.7428 39.955 32.7428Z",
    fill: "#DD9700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8874_29674",
    x: 0.800049,
    y: 0.800781,
    width: 70.4,
    height: 70.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.768627 0 0 0 0 0.301961 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8874_29674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8874_29674",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints5);
export default __webpack_public_path__ + "static/media/Points_5.4901addbaf1b406106e784378053c04b.svg";
export { ForwardRef as ReactComponent };